module.exports = __webpack_public_path__ + "static/media/exhibition-services-img10.7d62548a.jpg";